<template>
    <div >

        <h3>Comments</h3>
        <div class="container">
            <div class="row">
                <div class="col-sm">

         
            <div v-for="(comment,index) in comments" :key="index" class="media mb-4">
                  <img class="d-flex mr-3 rounded-circle" src="http://placehold.it/50x50" alt="">
                  <div class="media-body">
                     <h5 class="mt-0">{{ comment.course_str }}</h5>
                     <h6 class="ml-2">Grade Received: {{comment.grade_str}}</h6>
                     <h6 class="ml-2">Overall Quality: {{comment.quality}} </h6>
                     <h6 class="ml-2">Difficulty Level: {{comment.difficulty}}</h6>
                     {{comment.comment}}
                  </div>
               </div>

            <!-- Comment with nested comments -->




                </div>
            </div>
        </div>

    </div>
 </template>
 
 <script>
import axios from 'axios'
import datalabels from 'chartjs-plugin-datalabels'
import { mapState, mapMutations, mapActions } from 'vuex'

 export default {
    name: 'comments',
    data() {
        return {

            comments: [],

   
        }

    },
    watch: {
        profInfo() {
            if(this.profInfo['FirstName']) {
                this.getCommentsFromProf()
                //console.log(this.comments)
            }
        }
    },
    created() {
        this.initialize()
    },
    
    methods: {
        initialize() {
            
            //await this.something();
            // await this.createChart();

            //await this.getCommentsFromProf();
            
    

        },
        async something() {
            console.log("Create Chart is being initialized")
        },

        getCommentsFromProf() { //https://faceclass-221a7.appspot.com    http://localhost:3000 https://us-central1-faceclass-221a7.cloudfunctions.net/nodecruz/
            var bodyFormData = {
              'prof_id' : this.profInfo.ID
            }

            this.$store.state.loading = true

            var vm = this
            axios({
              method: 'post',
              
              url: 'https://us-central1-faceclass-221a7.cloudfunctions.net/nodecruz/getcommentsfromprofid',
              data: bodyFormData,
              config: { headers: {'Content-Type': 'application/json' }}
              })
              .then(function (response) {
                vm.$store.state.loading = false
                vm.comments = response.data
                //console.log(response.data)
                //console.log('hi how are you')
                //console.log(vm.comments[0]);
                
              })
              .catch(function (response) {
   
                  console.log(response);
              });        
         }



    },
    computed: {
        ...mapState([
      'profInfo',
    ]),

    },
    mounted() {




        

    }
 }
 
 </script>